import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommunicationService } from '../../services/communication/communication.service';
import $ from 'jquery';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit, OnDestroy {

  public loaderText: string;
  private currentApiSub: Subscription;
  private customLoaderSub: Subscription;
  private currentLoaderId: string;

  constructor(private communicationService: CommunicationService) { }

  ngOnInit() {
    // current api subscription to handle display of custom loaders
    this.currentApiSub = this.communicationService.getCurrentApis().subscribe(apis => {
      if (apis && apis.length) {
        this.currentLoaderId = apis[0].loaderId;
        // showing custom loader set in api list
        $('#' + this.currentLoaderId).show();
      } else {
        $('#' + this.currentLoaderId).hide();
      }
    });
    this.showLoader();
  }

  // to show loader other than api call
  showLoader() {
    this.customLoaderSub = this.communicationService.getShowHideLoader().subscribe((loaderData: any) => {
      if (loaderData) {
        if (loaderData.isShow) {
          this.currentLoaderId = loaderData.loaderId;
          // showing custom loader set in api list
          $('#' + this.currentLoaderId).show();
        } else {
          this.currentLoaderId = loaderData.loaderId;
          $('#' + this.currentLoaderId).hide();
        }
      }
    });
  }
  ngOnDestroy() {
    if (this.currentApiSub) {
      this.currentApiSub.unsubscribe();
    }
    if (this.customLoaderSub) {
      this.customLoaderSub.unsubscribe();
    }
  }
}
